/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React, {lazy} from 'react'
import {LoginLayout} from '../layouts'
import {NewLoginProvider} from '../context/NewLoginContext'
import {Route} from 'react-router-dom'

const SignIn = lazy(() => import('../pages/SignIn'))
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'))

export const NewLoginRoutes = (
  <Route
    path="/login/canvas"
    element={
      <NewLoginProvider>
        <LoginLayout />
      </NewLoginProvider>
    }
  >
    <Route index={true} element={<SignIn />} />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="*" element={<SignIn />} />
  </Route>
)
